<template>

  <product-filter
    v-model="model"
    :products="productFilterOptions"
    :loading="loading"
  />

</template>

<script setup lang="ts">

import { computed, watch } from 'vue'
import ProductFilter, { type ProductOption } from '../../../ProductFilter.vue'
import type LocationProduct from '../../../../models/LocationProduct'

/**
 * Props
 */

interface Props {
  locationProducts: LocationProduct[]
  loading: boolean
  hasOnDemandLps: boolean
  hasParcsLps: boolean
}

const props = defineProps<Props>()

type NumberOrString = number | string
const model = defineModel<NumberOrString[]>({default: []})

// When the list of LPs changes, enable all of the new LPs in the filters.
watch(() => props.locationProducts, () => {
  const modelValue: (number | string)[] = props.locationProducts.filter(lp => lp.product.verticalType !== 'parcs').map(lp => lp.ID)
  if (props.hasParcsLps) {
    modelValue.push('parcs')
  }
  if (props.hasOnDemandLps) {
    modelValue.push('on_demand')
  }
  model.value = modelValue
})


const productFilterOptions = computed<ProductOption[]>(() => {

  const options: ProductOption[] = props.locationProducts.filter(lp => ['parcs', 'on_demand'].includes(lp.product.verticalType) === false).map(lp => {
    return {
      id: lp.ID,
      name: lp.product?.name ?? 'unknown',
      vertical: lp.product.verticalType,
    }
  })

  // PARCS and On-Demand LPs get merged into a single item

  if (props.hasParcsLps) {
    options.push({
      id: 'parcs',
      name: 'PARCS',
      vertical: 'parcs',
    })
  }

  if (props.hasOnDemandLps) {
    options.push({
      id: 'on_demand',
      name: 'On-Demand',
      vertical: 'on_demand',
    })
  }

  return options

})

</script>
